import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";
import { VoiceButton } from "./VoiceButton";

interface VoiceTextareaFieldProps {
  id: string;
  label: string;
  placeholder: string;
  value: string;
  rows?: number;
  disabled: boolean;
  onChange: (value: string) => void;
  hint?: string;
  containerClassName?: string;
  labelClassName?: string;
  hintClassName?: string;
  buttonClassName?: string;
  recordingButtonClassName?: string;
  textareaClassName?: string;
}

export function VoiceTextareaField({
  id,
  label,
  placeholder,
  value,
  rows = 4,
  disabled,
  onChange,
  hint,
  containerClassName,
  labelClassName,
  hintClassName,
  buttonClassName,
  recordingButtonClassName,
  textareaClassName,
}: VoiceTextareaFieldProps) {
  return (
    <div className={cn("rounded-[24px] border border-slate-200 bg-white p-4 shadow-sm sm:p-5", containerClassName)}>
      <div className="mb-3 flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
        <div className="space-y-1">
          <Label htmlFor={id} className={cn("text-sm font-semibold leading-5 text-slate-900", labelClassName)}>
            {label}
          </Label>
          {hint ? <p className={cn("text-xs leading-5 text-slate-500", hintClassName)}>{hint}</p> : null}
        </div>
        <VoiceButton
          onTranscript={onChange}
          disabled={disabled}
          className={cn("shrink-0 rounded-2xl border-slate-200 bg-slate-50 px-3 text-xs font-semibold text-slate-600 hover:bg-slate-100", buttonClassName)}
          recordingClassName={cn("border-primary/30 bg-primary/10 text-primary hover:bg-primary/15", recordingButtonClassName)}
        />
      </div>
      <Textarea
        id={id}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        rows={rows}
        className={cn("form-input min-h-[132px] resize-y py-3", textareaClassName)}
      />
    </div>
  );
}
